'use strict';

import React from 'react';
import { OTLink } from '../tag/OTLink';
import OTButton from '../tag/OTButton';
import OTIcon from '../tag/OTIcon';
import BaseQuestionnaireListItem from './BaseQuestionnaireListItem';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';

const AivaListItem = ({aivaProcess}) => {
  const history = useHistory();
  const viewAiva = () => {
    history.push(`/questionnaires/aiva/${aivaProcess.id}`);
  };

  return (
    <BaseQuestionnaireListItem
      left={
        <>
          {status === 'COMPLETED' || status === 'MODIFIABLE' ? (
            <OTLink
              className={'ot-queryitem__name completed'}
              link={'/questionnaires' + link}
            >
              {'Aiva prosessi'}
            </OTLink>
          ) : (
            <span className={'ot-queryitem__name'}>{'Aiva prosessi'}</span>
          )}
        </>
      }
      right={
        <>
          <OTButton
            color={'light'}
            className={'pull-right ot-queryitem__button'}
            onClick={viewAiva}
          >
            <OTIcon
              config={{ type: 'fa', name: 'icon-info-sign' }}
              style={{ marginRight: '8px' }}
            />
            <FormattedMessage id={'Näytä'} />
          </OTButton>
        </>
      }
    />
  );
};

export default AivaListItem;
